"use client"

import { useState } from "react"
import { Edit, Calendar, MapPin } from "lucide-react"
import config from "../config"

const EventHeader = ({ event, isCreator, isLoggedIn, navigate, event_slug }) => {
  const [isImageModalOpen, setIsImageModalOpen] = useState(false)

  return (
    <>
      {/* Hero Image Section */}
      <div className="relative overflow-hidden rounded-2xl shadow-2xl mb-8">
        <div className="relative cursor-pointer group" onClick={() => setIsImageModalOpen(true)}>
          <img
            src={`${config.MEDIA_BASE_URL}${event.thumbnail_photo}`}
            alt="Event Thumbnail"
            className="w-full h-96 object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />

          {/* Category Badge */}
          <div className="absolute top-6 right-6 bg-blue-600 text-white px-4 py-2 rounded-full shadow-lg font-medium">
            {event.category}
          </div>

          {/* Edit Button for Creator */}
          {isLoggedIn && isCreator && (
            <button
              onClick={(e) => {
                e.stopPropagation()
                navigate(`/events/${event_slug}/update`)
              }}
              className="absolute top-6 left-6 bg-white/90 hover:bg-white text-gray-800 px-4 py-2 rounded-full shadow-lg font-medium transition-all duration-200 flex items-center gap-2"
            >
              <Edit size={16} />
              Edit Event
            </button>
          )}

          {/* Event Title Overlay */}
          <div className="absolute bottom-6 left-6 right-6">
            <div className="flex flex-wrap items-center justify-between gap-4">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-2 drop-shadow-lg">{event.title}</h1>
            </div>
            <div className="flex flex-wrap gap-4 text-white/90">
              <div className="flex items-center gap-2">
                <Calendar size={18} />
                <span className="font-medium">
                  {new Date(event.date).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}{" "}
                  at {event.time}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin size={18} />
                <span className="font-medium">{event.location}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {isImageModalOpen && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4">
          <div className="relative max-w-6xl max-h-full">
            <img
              src={`${config.MEDIA_BASE_URL}${event.thumbnail_photo}`}
              alt="Enlarged Event Thumbnail"
              className="max-w-full max-h-full rounded-lg shadow-2xl"
            />
            <button
              className="absolute top-4 right-4 bg-red-600 hover:bg-red-700 text-white p-3 rounded-full text-xl transition-colors duration-200"
              onClick={() => setIsImageModalOpen(false)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  )
}

export default EventHeader
